import {
  complement,
  isNil,
} from 'ramda'

export default complement(isNil)
